import { useUiStore } from '../state/createUiStore';

export const useEditModal = () => {
  const showEditModal = useUiStore((state) => state.showEditModal);
  return { showEditModal };
};